import React from 'react';

const SearchField = ({ value, onChange, placeholder = 'Search', autoFocus = true, autoComplete = 'off', className = '' }) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      data-1p-ignore="true"
      onChange={onChange}
      className={`w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm text-black placeholder-gray-400 focus:outline-none dark:border-white/10 dark:bg-neutral-700/50 dark:text-neutral-200 dark:placeholder-neutral-400 ${className}`}
    />
  );
};

export default SearchField;
